import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import SquadPlayer from '../Team/SquadPlayer';
import { useSquad } from '../../hooks/squad';

import Carousel from '../Carousel';

function TopPlayers({ match }) {
  const [homeTeamSquad, homeTeamSquadLoading] = useSquad(match?.homeTeamAbbrv);
  const [visitingTeamSquad, visitingTeamSquadLoading] = useSquad(
    match?.visitingTeamAbbrv
  );
  const getTopPlayers = () => {
    if (visitingTeamSquad && homeTeamSquad) {
      const homeTeamLeadersNested = Object.keys(homeTeamSquad).map(
        (x) => homeTeamSquad[x]
      );
      const homeTeamLeadersNew = _.flatten(homeTeamLeadersNested);
      const homeTeam = _.orderBy(
        homeTeamLeadersNew,
        'currentSeasonStats.goals',
        'desc'
      )
        .splice(0, 3)
        .map((p) => ({
          ...p,
          matchTeam: match.homeTeamAbbrv,
          team: Object.create({
            logoImageUrl: match.homeTeamLogo,
          }),
        }));

      const visitingTeamLeadersNested = Object.keys(visitingTeamSquad).map(
        (x) => visitingTeamSquad[x]
      );
      const visitingTeamLeadersNew = _.flatten(visitingTeamLeadersNested);
      const visitingTeam = _.orderBy(
        visitingTeamLeadersNew,
        'currentSeasonStats.goals',
        'desc'
      )
        .splice(0, 3)
        .map((p) => ({
          ...p,
          matchTeam: match.visitingTeamAbbrv,
          team: Object.create({
            logoImageUrl: match.visitingTeamLogo,
          }),
        }));

      return homeTeam.concat(visitingTeam);
    }

    return [];
  };

  const topPlayers = getTopPlayers();

  if (homeTeamSquadLoading || visitingTeamSquadLoading)
    return <div>Laddar...</div>;
  return (
    <>
      <div className="row justify-content-center">
        <div className="col-12 tabs-column d-flex px-sm-4 align-items-center mb-4 mt-5">
          <h2 className="heading-h6 heading-sm-h3 flex-grow-1">
            Spelare att hålla koll på
          </h2>
        </div>
      </div>
      <div className="row justify-content-center">
        <div className="col-12 tabs-column">
          <Carousel
            isReady={Boolean(topPlayers)}
            itemSelector=".carousel--item"
            numberOfItems={topPlayers.length}
            containerClassName="overflow-x-auto overflow-x-lg-hidden d-flex flex-nowrap flex-lg-wrap row article-scroll__container--carousel"
          >
            {topPlayers?.map((p) => (
              <SquadPlayer player={p} team={p.team} />
            ))}
          </Carousel>
        </div>
      </div>
    </>
  );
}

TopPlayers.propTypes = {
  match: PropTypes.shape({
    homeTeamAbbrv: PropTypes.string.isRequired,
    visitingTeamAbbrv: PropTypes.string.isRequired,
  }).isRequired,
};

export default TopPlayers;
